import Box from '@/Atoms/Box';
import React, {useCallback, useEffect, useState, useMemo, useContext} from 'react';
import {styles} from './styles';
import uuid from 'react-native-uuid';
// import {uuid} from 'uuidv4';
import ChessboardComponent from 'chessboard-package';
import CCText from '@/Atoms/CCText';
import {useGetStudyGamesDetail} from '@/Hooks/GetStudyGamesDetailsApi/useGetStudyGamesDetail';
import {useGetChapterMoves} from '@/Hooks/GetStudyGamesDetailsApi/useGetChapterMoves';
import {useNavigation} from '@react-navigation/native';
import {useRoute} from '@react-navigation/native';
import {ScrollView, Switch, TouchableOpacity, View} from 'react-native';
import {Hover} from 'react-native-gesture-handler';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import MovesList from '@/Atoms/MovesList';
import WorkbookMovesList from '@/Atoms/WorkbookMovesList';
import AntDesign from 'react-native-vector-icons/AntDesign';
import SlideModal from '@/Atoms/SlideModal';
import CCTextInput from '@/Atoms/CCTextInput';
import Spacer from '@/Atoms/Spacer';
import CCButton from '@/Atoms/CCButton';
import useManageParticipants from '@/Hooks/ManageStudyParticipantsApi/useManageParticipants';
import CCLoader from '@/Atoms/CCLoader';
import ConfirmationModal from '@/Components/ConfirmationModal';
import useUpdatePgn from '@/Hooks/ManageStudyParticipantsApi/useUpdatePgn';
import Ionicons from 'react-native-vector-icons/Ionicons';
import {
  STARTING_FEN,
  cleanPgn,
  generateMoveData,
  generatePGN,
  getStartingFenFromPgn,
  getUserDetails,
} from '@/Utils/CommonUtils';
import useRandomUserlStore from '../Home/store';
import {ScreenName} from '@/navigators/StackConstants';
import CCTabs from '@/Atoms/CCTabs';
import Participants from './Component/Participants';
import Chapters from './Component/Chapters';
import StockfishEngine from '@/Components/StockfishEngine';
import {FontSizes, WINDOW_HEIGHT, WINDOW_WIDTH} from '@/Utils/Dimensions';
import useStudySaveAlternateMoves from '@/Hooks/StudyAlternateMoves/useStudySaveAlternateMoves';
import useStudyUpdateAnnotation from '@/Hooks/StudyUpdateAnnotation/useStudyUpdateAnnotation';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import UpAndDownArrow from '@/Animations/UpAndDownArrow';
import BottomSheet from '@/Atoms/BottomSheet';
import {TabView} from 'react-native-tab-view';
import {renderTabBarPill} from '@/Components/TabBar/TabBarPill';
import ConditionalRender from '@/Atoms/ConditionalRender';
import {MOBILE_HEADER_HEIGHT} from '@/Utils/Constants';
import useChessboardColorTheme from '@/Hooks/ChessboardColorTheme/useChessboardColorTheme';
import CCChessMoves from '@/Atoms/CCChessMoves';
import ChessboardWithArrow from '@/Components/ChessboardWithArrow';
import {SocketProvider} from '@/Providers/SocketProvider';
import {useNotificationStore} from '@/Store/useNotificationStore';
import SettingsTab from './Component/SettingsTab';

function Study() {
  const {isMobileOrTab} = useMediaQuery();
  const route = useRoute();
  const gameClient = useContext(SocketProvider);

  const gameId = route?.params?.study_id;
  const {
    data: studyDetails,
    isLoading,
    error,
    refetch,
  } = useGetStudyGamesDetail(gameId);
  const [chessboardHeight, setChessboardHeight] = useState(0);

  const onChessboardLayout = event => {
    const {height} = event.nativeEvent.layout;
    setChessboardHeight(height);
  };

  const [selectedUser, setSelectedUser] = useState(null);
  const [enableStockfish, setEnableStockfish] = useState(false);
  const [loading, setLoading] = useState(false);
  const [movesList, setMovesList] = useState({});
  const [tabSelected, setTabSelected] = useState(0);
  const navigation = useNavigation();
  const [openRemoveConfimation, setOpenRemoveConfimation] = useState({
    flag: false,
    bodyTxt: '',
    callbackFunc: () => {},
  });
  const [moveSelected, setmoveSelected] = useState({
    move: '',
    id: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
    fen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
    lastFen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  });
  const [allIds, setAllIds] = useState([]);
  const [annotationToShow, setAnnotationToShow] = useState('');
  const [userDetailsData, setUserDetailsData] = useState(null);
  const [isOwner, setIsOwner] = useState(false);
  const [isSyncOn, setIsSyncOn] = useState(true);

  const [participantsList, setParticipantsList] = useState([]);
  const [chapterList, setChapterList] = useState([]);
  const [moveSequences, setMoveSequences] = useState({});
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [index, setIndex] = React.useState(0);
  const [newChapterCreated, setNewChapterCreated] = useState(false);
  const [boardOrientation, setBoardOrientation] = useState(
    selectedChapter?.orientation === 'W' ? 'white' : 'black',
  );
  const {
    data: chapterMovesResponse,
    isLoading: isChapterMovesLoading,
    refetch: refetchChapterMoves,
  } = useGetChapterMoves(selectedChapter?.id);
  const currentChapterMoves = selectedChapter?.id
    ? movesList[selectedChapter.id]
    : undefined;

  const handleFlipBoard = () => {
    setBoardOrientation(prev => (prev === 'white' ? 'black' : 'white'));
  };

  const onParentLayout = (_event: any) => {};

  const [routes] = React.useState(
    [
      {key: 'PARTICIPANTS', title: 'Participants'},
      {key: 'CHAPTERS', title: 'Chapters'},
      // { key: "previousTournaments", title: "Previous Tournaments" },
    ]?.filter(i => i),
  );
  const {
    mutateAsync: saveAlternateMoves,
    isLoading: isSavingMoves,
    isError,
  } = useStudySaveAlternateMoves();

  const {
    mutateAsync: saveAnnotation,
    isLoading: isSavingAnnotation,
    isError: isSavingAnnotationError,
  } = useStudyUpdateAnnotation();

  const chessboardColorTheme = useChessboardColorTheme();
  // const participantsList = ['You', 'Player 1', 'Player 2'];
  // const {
  //   mutate: manageParticipants,
  //   isLoading: isUpdatingPlayers,
  //   data: manageParticipantsData,
  //   error: manageParticipantsError,
  // } = useManageParticipants();
  const [playerOrChaptersSelect, setPlayerOrChaptersSelect] = useState(0);
  const {
    mutate: updatePgn,
    isLoading: updatePgnLoading,
    // data: updatedPgnData,
    // error: updatedPgnError,
  } = useUpdatePgn(() => {}, handleupdatePgnError);
  // const {userDetails} = useRandomUserlStore();
  const handleupdatePgnError = data => {
    console.log(data, 'error new');
  };

  const handleSaveAnnotation = async () => {
    if (annotationToShow?.length < 1 || !isSyncOn) return;
    if (!moveSelected?.id) return;
    const chapterId = selectedChapter?.id;

    try {
      await saveAnnotation({
        move_id: moveSelected?.id,
        annotation: annotationToShow,
      });
    } catch (error) {
      console.warn('Failed to save annotation:', (error as any)?.message);
      return;
    }
    setmoveSelected(prev => ({...prev, annotation: annotationToShow}));
    // Update the movelist
    setMovesList(prevMovesList => {
      const updatedMoves = prevMovesList[chapterId]?.map(move => {
        if (move.id === moveSelected.id) {
          return {
            ...move,
            annotation: annotationToShow,
          };
        }
        return move;
      });

      return {
        ...prevMovesList,
        [chapterId]: updatedMoves,
      };
    });
  };

  const handleSaveAnnotationIcon = async annotationIconSelected => {
    if (!isSyncOn) return;
    if (!moveSelected?.id) return;
    const chapterId = selectedChapter?.id;

    try {
      await saveAnnotation({
        move_id: moveSelected?.id,
        annotation_icon: annotationIconSelected,
      });
    } catch (error) {
      console.warn('Failed to save annotation icon:', (error as any)?.message);
      return;
    }
    setmoveSelected(prev => ({
      ...prev,
      annotation_icon: annotationIconSelected,
    }));

    // Update the movelist
    setMovesList(prevMovesList => {
      const updatedMoves = prevMovesList[chapterId]?.map(move => {
        if (move.id === moveSelected.id) {
          return {
            ...move,
            annotation: annotationToShow,
            annotation_icon: annotationIconSelected,
          };
        }
        return move;
      });

      return {
        ...prevMovesList,
        [chapterId]: updatedMoves,
      };
    });
  };
  const getCurrentLine = (moves, selectedMove) => {
    if (!selectedMove) return moves;
    const findLine = (movesArr, targetId) => {
      for (let i = 0; i < movesArr.length; i++) {
        const move = movesArr[i];
        if (move.id === targetId) {
          return movesArr.slice(0, i + 1);
        }
        if (move.child_moves) {
          const childLine = findLine(move.child_moves, targetId);
          if (childLine) {
            return movesArr.slice(0, i + 1).concat(childLine);
          }
        }
      }
      return null;
    };
    return findLine(moves, selectedMove.id) || moves;
  };

  const currentLine = getCurrentLine(movesList[selectedChapter?.id] || [], moveSelected);
  const setRefetchStudy = useNotificationStore(state => state.setRefetchStudy);
  const refetchStudyFlag = useNotificationStore(state => state.refetchStudy);

  useEffect(() => {
    setAnnotationToShow(moveSelected?.annotation || '');
  }, [moveSelected]);

  // useEffect(() => {
  //   if (isSavingAnnotation) {
  //     refetchStudy();
  //   }
  // }, [isSavingAnnotation]);

  const saveMove = async ({
    parent_id,
    san,
    fen,
    chapter_id,
  }: {
    parent_id: string;
    san: string;
    fen: string;
    chapter_id;
  }) => {
    try {
      const savedMoveId = await saveAlternateMoves({
        parent_id,
        san,
        fen,
        chapter_id,
      });
      return savedMoveId;
    } catch (error) {
      console.error('Error saving move:', error);
      return null;
    }
  };

  // const isOwner = useMemo(async () => {
  //   let userDetails = await getUserDetails();
  //   userDetails = JSON.parse(userDetails);
  //   return userDetails?.mobile_number === data?.data?.owner?.mobile_number;
  // }, [data, getUserDetails]);

  // const userDetailsData = useMemo(async () => {
  //   let userDetails = await getUserDetails();
  //   userDetails = JSON.parse(userDetails);
  //   return userDetails;
  // }, [data, getUserDetails]);

  // const handleParticipants = (
  //   phone: string,
  //   action: 'add' | 'remove' = 'add',
  // ) => {
  //   manageParticipants({
  //     phone: phone,
  //     action: action,
  //     gameId: gameId,
  //   });
  // };

  const refetchStudy = useCallback(async () => {
    setLoading(true);
    await Promise.all([refetch(), refetchChapterMoves()]);
    setLoading(false);
  }, [refetch, refetchChapterMoves]);

  useEffect(() => {
    if (refetchStudyFlag) {
      refetchStudy();
      setRefetchStudy(false);
    }
  }, [refetchStudyFlag, refetchStudy, setRefetchStudy]);

  const isMoveInTree = (moves, targetMove) => {
    if (!targetMove || !moves?.length) return false;
    for (const move of moves) {
      if (
        (targetMove?.id && move?.id === targetMove.id) ||
        (!targetMove?.id && move?.fen === targetMove?.fen)
      ) {
        return true;
      }
      if (isMoveInTree(move?.child_moves || [], targetMove)) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    const fallbackMove = {
      move: '',
      fen:
        selectedChapter?.fen ||
        'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
      lastFen:
        selectedChapter?.fen ||
        'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
    };
    const firstMove = currentChapterMoves?.[0] || fallbackMove;
    const selectedStillValid = isMoveInTree(currentChapterMoves || [], moveSelected);
    if (!selectedStillValid) {
      setmoveSelected(firstMove);
    }
  }, [selectedChapter?.id, selectedChapter?.fen, currentChapterMoves?.length]);

  const resetBoard = () => {
    setmoveSelected({
      move: '',
      fen:
        studyDetails?.data?.starting_position ||
        'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
      lastFen:
        studyDetails?.data?.starting_position ||
        'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
    });
  };

  const updateUserData = async gameData => {
    let userDetails = await getUserDetails();
    userDetails = JSON.parse(userDetails);
    // return userDetails?.mobile_number === data?.data?.owner?.mobile_number;
    setIsOwner(
      userDetails?.mobile_number ===
        gameData?.data?.owner_details?.mobile_number,
    );
    setUserDetailsData(userDetails);
  };

  // useEffect(() => {
  //   debugger;
  // }, []);

  useEffect(() => {
    setLoading(false);
    if (studyDetails?.data) {
      updateUserData(studyDetails);

      const allPlayers = [
        {
          ...studyDetails?.data?.owner_details,
          pgn: studyDetails?.data?.pgn,
          isDeletable: false,
        },
        ...studyDetails?.data?.participants?.map(i => ({
          ...i,
          isDeletable: true,
        })),
      ];

      setParticipantsList(allPlayers);
      let allChapters = studyDetails?.data?.chapters;
      setChapterList(allChapters);
      const firstChapter = allChapters?.[0];
      if (
        firstChapter &&
        (!selectedChapter ||
          !allChapters?.some(chapter => chapter?.id === selectedChapter?.id))
      ) {
        setSelectedChapter(firstChapter);
        setBoardOrientation(firstChapter?.orientation === 'W' ? 'white' : 'black');
      }
      if (newChapterCreated) {
        setSelectedChapter(
          studyDetails?.data?.chapters?.[
            studyDetails?.data?.chapters?.length - 1
          ],
        );
      }
      setSelectedUser(allPlayers?.[0]);
    } else {
      // navigation?.navigate(ScreenName?.Dashboard);
    }
  }, [studyDetails]);

  useEffect(() => {
    if (!selectedChapter?.id || !chapterMovesResponse?.data) {
      return;
    }
    const chapterData = chapterMovesResponse.data;
    if (chapterData.chapter_id !== selectedChapter.id) {
      return;
    }

    let parsedMovesForPgn: any = null;
    if (chapterData.moves?.length > 0) {
      parsedMovesForPgn = chapterData.moves.map((move, index) => ({
        ...move,
        move: move?.san,
        newFen: move?.fen,
        isMainBranch: true,
        lastFen:
          chapterData.moves?.[index - 1]?.fen || chapterData.fen,
      }));
    } else if (chapterData?.pgn) {
      const startignFenFromPgn = getStartingFenFromPgn(
        cleanPgn(chapterData?.pgn),
      );
      parsedMovesForPgn = generateMoveData(
        startignFenFromPgn || STARTING_FEN,
        cleanPgn(chapterData?.pgn),
      );
    } else {
      parsedMovesForPgn = [];
    }

    setMovesList(prev => ({...prev, [selectedChapter.id]: parsedMovesForPgn}));
  }, [chapterMovesResponse, selectedChapter?.id]);

  // const handleStockfishResult = result => {
  //   debugger;
  // };
  const handlePositionChange = async tempPosition => {
    const chapterId = selectedChapter?.id;
    if (!chapterId) return;

    const {newFen, lastFen, san} = tempPosition;
    const currentMoves = movesList[chapterId] || [];

    // Check if extending the main line (last move in main array)
    if (currentMoves.length > 0 && currentMoves[currentMoves.length - 1].fen === lastFen) {
      // Extending main line
      let tempId = `${newFen}_${uuid.v4()}`;
      const newMainMove = {
        fen: newFen,
        lastFen,
        move: san,
        san,
        id: tempId,
        newFen,
        isMainBranch: true,
        child_moves: [],
      };
      setMovesList(prev => ({
        ...prev,
        [chapterId]: [...currentMoves, newMainMove],
      }));
      setmoveSelected(newMainMove);

      // Save to backend in parallel
      if (isOwner && isSyncOn) {
        saveMove({
          chapter_id: chapterId,
          parent_id: moveSelected?.id,
          san,
          fen: newFen,
        }).then(saved => {
          if (saved?.move_id) {
            setMovesList(prev => {
              const updated = (prev[chapterId] || []).map(m =>
                m.id === tempId ? {...m, id: saved.move_id} : m
              );
              return {
                ...prev,
                [chapterId]: updated,
              };
            });
            setmoveSelected(prev =>
              prev?.id === tempId ? {...prev, id: saved.move_id} : prev
            );
          }
        });
      }
      return;
    }

    // Otherwise, add as a branch
    const findOrAddInTree = async (moves, parentFen, childFen, childSan) => {
      for (let i = 0; i < moves.length; i++) {
        const move = moves[i];
        if (move.fen === parentFen) {
          // Re-playing the next mainline move — just navigate, no new node
          if (i + 1 < moves.length && moves[i + 1].fen === childFen) {
            return {navigateTo: moves[i + 1], updatedMoves: moves};
          }
          // Existing branch child — just navigate
          const existingChild = (move.child_moves || []).find(
            c => c.fen === childFen,
          );
          if (existingChild) {
            return {navigateTo: existingChild, updatedMoves: moves};
          }
          // New branch — optimistically insert into UI
          let tempId = `${childFen}_${uuid.v4()}`;
          const newChild = {
            fen: childFen,
            lastFen: parentFen,
            move: childSan,
            san: childSan,
            id: tempId,
            newFen: childFen,
            isMainBranch: false,
            child_moves: [],
          };
          const updatedMoves = moves.map((m, idx) =>
            idx === i
              ? {...m, child_moves: [...(m.child_moves || []), newChild]}
              : m,
          );
          setmoveSelected(newChild);

          // Save to backend in parallel, and update ID if needed
          if (isOwner && isSyncOn) {
            saveMove({
              chapter_id: chapterId,
              parent_id: move.id || moveSelected?.id,
              san: childSan,
              fen: childFen,
            }).then(saved => {
              if (saved?.move_id) {
                setMovesList(prev => {
                  // Recursively update the id in the tree
                  const updateIdInTree = movesArr =>
                    movesArr.map(m => {
                      if (m.id === tempId) {
                        return {...m, id: saved.move_id};
                      }
                      if (m.child_moves && m.child_moves.length > 0) {
                        return {...m, child_moves: updateIdInTree(m.child_moves)};
                      }
                      return m;
                    });
                  return {
                    ...prev,
                    [chapterId]: updateIdInTree(prev[chapterId] || []),
                  };
                });
                setmoveSelected(prev =>
                  prev?.id === tempId ? {...prev, id: saved.move_id} : prev
                );
              }
            });
          }
          // Return so the rest of the logic doesn't run
          return {navigateTo: newChild, updatedMoves};
        }
        if (move.child_moves?.length > 0) {
          const childResult = await findOrAddInTree(
            move.child_moves,
            parentFen,
            childFen,
            childSan,
          );
          if (childResult.navigateTo) {
            const updatedMoves = moves.map((m, idx) =>
              idx === i ? {...m, child_moves: childResult.updatedMoves} : m,
            );
            return {navigateTo: childResult.navigateTo, updatedMoves};
          }
        }
      }
      return {navigateTo: null, updatedMoves: moves};
    };

    const {navigateTo, updatedMoves: treeUpdatedMoves} = await findOrAddInTree(
      currentMoves,
      lastFen,
      newFen,
      san,
    );

    // If a move was found or optimistically added, stop here
    if (navigateTo) {
      setMovesList(prev => ({
        ...prev,
        [chapterId]: treeUpdatedMoves,
      }));
      return;
    }

    // Parent not found in tree — this shouldn't happen now, but fallback
    const existingMainMove = currentMoves.find(m => m.fen === newFen);
    if (existingMainMove) {
      setmoveSelected(existingMainMove);
      return;
    }

    // Fallback: add to main line (though unlikely)
    let tempId = `${newFen}_${uuid.v4()}`;
    const newMainMove = {
      fen: newFen,
      lastFen,
      move: san,
      san,
      id: tempId,
      newFen,
      isMainBranch: true,
      child_moves: [],
    };
    setMovesList(prev => ({
      ...prev,
      [chapterId]: [...currentMoves, newMainMove],
    }));
    setmoveSelected(newMainMove);

    // Save to backend in parallel
    if (isOwner && isSyncOn) {
      saveMove({
        chapter_id: chapterId,
        parent_id: moveSelected?.id,
        san,
        fen: newFen,
      }).then(saved => {
        if (saved?.move_id) {
          setMovesList(prev => {
            const updated = (prev[chapterId] || []).map(m =>
              m.id === tempId ? {...m, id: saved.move_id} : m
            );
            return {
              ...prev,
              [chapterId]: updated,
            };
          });
          setmoveSelected(prev =>
            prev?.id === tempId ? {...prev, id: saved.move_id} : prev
          );
        }
      });
    }
  };

  const renderScene = (rendererSceneProps: any) => {
    const {route: tempRoute} = rendererSceneProps;
    // let returnJSX = <></>;
    switch (tempRoute.key) {
      case 'PARTICIPANTS':
        return (
          // <ScrollView style={{flex: 1, paddingVertical: 10}}>
          <Participants
            participantsList={participantsList}
            userDetailsData={userDetailsData}
            gameId={gameId}
            setLoading={setLoading}
            refetchStudy={refetchStudy}
            isOwner={isOwner}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            setOpenRemoveConfimation={setOpenRemoveConfimation}
          />
          // </ScrollView>
        );
      case 'CHAPTERS':
        return (
          // <ScrollView style={{flex: 1, paddingVertical: 10}}>
          <Chapters
            chaptersList={chapterList}
            gameId={gameId}
            setLoading={setLoading}
            refetchStudy={refetchStudy}
            isOwner={isOwner}
            selectedChapter={selectedChapter}
            setSelectedChapter={setSelectedChapter}
            setNewChapterCreated={setNewChapterCreated}
            setBoardOrientation={setBoardOrientation}
          />
          // </ScrollView>
        );

      default:
        return PuzzleDetailsJSX;
    }
    // switch (tempRoute.key) {
  };

  const playerOrChaptersTab = [
    {
      key: 0,
      label: 'Chapters',
      // eslint-disable-next-line react/no-unstable-nested-components
      component: () => (
        // <ScrollView style={{flex: 1}}>
        <Chapters
          chaptersList={chapterList}
          gameId={gameId}
          setLoading={setLoading}
          refetchStudy={refetchStudy}
          isOwner={isOwner}
          selectedChapter={selectedChapter}
          setSelectedChapter={setSelectedChapter}
          setOpenRemoveConfimation={setOpenRemoveConfimation}
          setNewChapterCreated={setNewChapterCreated}
          setBoardOrientation={setBoardOrientation}
        />
        // </ScrollView>
      ),
    },
    {
      key: 1,
      label: 'Participants',
      // eslint-disable-next-line react/no-unstable-nested-components
      component: () => (
        // <ScrollView style={{flex: 1}}>
        <Participants
          participantsList={participantsList}
          userDetailsData={userDetailsData}
          gameId={gameId}
          setLoading={setLoading}
          refetchStudy={refetchStudy}
          isOwner={isOwner}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          setOpenRemoveConfimation={setOpenRemoveConfimation}
        />
        // </ScrollView>
      ),
    },
  ];

  const tabDetails = [
    {
      key: 0,
      label: 'Details',
      // eslint-disable-next-line react/no-unstable-nested-components
      component: () => leftComponent,
    },
    {
      key: 1,
      label: 'Moves',
      // eslint-disable-next-line react/no-unstable-nested-components
      component: () => (
        <>
          <Spacer spacing={10} />
          <MovesList
            gameMoves={currentLine}
            activeMove={moveSelected}
            setGameMoves={tempGameMoves => {
              setMovesList(tempGameMoves);
            }}
            // setClicked={setClicked}
            setmoveSelected={setmoveSelected}
            // useFeather={false}
          />
        </>
      ),
    },
  ];

  const leftComponent = (
    <>
      <Box type="row-space-between">
        {/* {isOwner && (
          <Box type="row-flex-end">
            <CCText
              fontWeight="semibold"
              color={isSyncOn ? CCColors.Green : CCColors.Error}>
              {isSyncOn ? 'Synced' : 'Not synced'}
            </CCText>
            <Spacer spacing={10} horizontal />
            <Switch
              trackColor={{
                false: updateColorWithOpacity(CCColors.Error, 0.2),
                true: updateColorWithOpacity(CCColors.Green, 0.2),
              }}
              thumbColor={isSyncOn ? CCColors.Green : CCColors.Error}
              // ios_backgroundColor="#3e3e3e"
              onValueChange={() => setIsSyncOn(!isSyncOn)}
              value={isSyncOn}
            />
          </Box>
        )} */}
        <CCText
          fontSize={FontSizes[18]}
          fontWeight="thunder"
          style={{padding: 10}}>
          {studyDetails?.data?.name}
        </CCText>
      </Box>
      <Box flex={0.8}>
        <ConditionalRender
          condition={isMobileOrTab}
          childrenA={
            <TabView
              lazy
              //   style={styles.contentContainerStyle}
              // @ts-ignore
              navigationState={{index: index, routes}}
              renderScene={renderScene}
              renderTabBar={renderTabBarPill}
              onIndexChange={setIndex}
              initialLayout={{width: WINDOW_WIDTH / 2}}
              // style={{height: '75vh'}}
            />
          }
          childrenB={
            <CCTabs
              tabIndex={playerOrChaptersSelect}
              tabItems={playerOrChaptersTab}
              handleTabChange={({route}) => {
                setPlayerOrChaptersSelect(parseInt(route.key, 10));
              }}
            />
          }
        />
      </Box>
      {/*       
      <Spacer spacing={10} />
      <Box flex={0.25}>
        <CCTextInput
          value={annotationToShow}
          onChangeText={text => setAnnotationToShow(text)}
          // label="Notes"
          placeholder="Notes"
          name="Notes"
          // style={{height: '80%'}}
          numberOfLines={4}
          multiline={true}
        />
        <Spacer spacing={2} />
        <TouchableOpacity
          style={[
            styles.addNewBox,
            (annotationToShow?.length < 1 || !isSyncOn) && styles.disabled,
          ]}
          onPress={handleSaveAnnotation}>
          <CCText textAlign="center" color={CCColors.White}>
            Save
          </CCText>
        </TouchableOpacity>
      </Box> */}
    </>
  );
  if (isMobileOrTab) {
    return (
      <Box style={styles.mobileContainer}>
        {/* <Box style={styles.infoContainer}> */}
        <Box flex={1} onLayout={onChessboardLayout}>
          <ChessboardWithArrow
            position={moveSelected?.fen || selectedChapter?.fen || 'start'}
            boardOrientation={boardOrientation}
            lastMoveFen={moveSelected?.lastFen}
            handleNewFen={handlePositionChange}
            disabled={isSavingMoves}
            colorTheme={chessboardColorTheme}
          />
        </Box>
        {console.log(chessboardHeight, 'chessboardHeight')}
        {/* <UpAndDownArrow /> */}
        {chessboardHeight && (
          <BottomSheet
            minHeight={WINDOW_HEIGHT - chessboardHeight - MOBILE_HEADER_HEIGHT}>
            {/* <View style={{flex: 1}}> */}
            <CCTabs
              tabIndex={tabSelected}
              tabItems={tabDetails}
              handleTabChange={({route}) => {
                setTabSelected(parseInt(route.key, 10));
                // if (route.key === 1) {
                //   setFilter('participant');
                // } else {
                //   setFilter('owner');
                // }
              }}
            />
            {/* </View> */}
          </BottomSheet>
        )}
        <CCLoader
          loading={
            loading ||
            isLoading ||
            isSavingAnnotation ||
            (!!selectedChapter && isChapterMovesLoading)
          }
        />
      </Box>
    );
  }

  return (
    <Box style={{flex: 1}}>
      <Box style={styles.container} onLayout={onParentLayout}>
        <Box style={styles.left}>
          {/* <ScrollView flex={1} style={{height: '85vh'}}> */}
          {leftComponent}
          {/* </ScrollView> */}
        </Box>
        <Box style={styles.center}>
          <Box style={styles.chessboardContainer}>
            <ChessboardWithArrow
              position={moveSelected?.fen || selectedChapter?.fen || 'start'}
              boardOrientation={boardOrientation}
              lastMoveFen={moveSelected?.lastFen}
              handleNewFen={handlePositionChange}
              disabled={isSavingMoves}
              colorTheme={chessboardColorTheme}
              annotation={moveSelected?.annotation_icon}
            />
            <Box style={styles.boardControls}>
              {isOwner ? (
                <Box style={styles.boardControlsLeft}>
                  <CCText
                    fontSize={12}
                    fontWeight="medium"
                    color={isSyncOn ? '#3DAB9E' : CCColors.Grey.Shade200}>
                    Sync
                  </CCText>
                  <Switch
                    trackColor={{
                      false: CCColors.Grey.Shade200,
                      true: '#3DAB9E',
                    }}
                    thumbColor={'#FFFFFF'}
                    onValueChange={() => setIsSyncOn(!isSyncOn)}
                    value={isSyncOn}
                  />
                </Box>
              ) : (
                <Box />
              )}
              <Box style={styles.boardControlsRight}>
                <SettingsTab
                  commentToShow={annotationToShow}
                  setCommentToShow={setAnnotationToShow}
                  isSyncOn={isSyncOn}
                  handleSaveComment={handleSaveAnnotation}
                  handleSaveAnnotationIcon={handleSaveAnnotationIcon}
                  annotation_icon={moveSelected?.annotation_icon}
                  handleFlipBoard={handleFlipBoard}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box style={styles.right}>
          <Box style={styles.infoHintCard}>
            <Ionicons name="information-circle-outline" size={14} color="#6b584d" />
            <CCText fontSize={11} color="#6b584d" style={{flex: 1, lineHeight: 17}}>
              Right-click the last move of a branch to promote or delete it.
            </CCText>
          </Box>
          <WorkbookMovesList
            gameMoves={movesList?.[selectedChapter?.id as any]}
            activeMove={moveSelected}
            setmoveSelected={setmoveSelected}
            setLoading={tempLoading => setLoading(tempLoading)}
            refetchStudy={refetchStudy}
          />
        </Box>
        <ConfirmationModal
          open={openRemoveConfimation?.flag}
          bodyTxt={openRemoveConfimation?.bodyTxt}
          handleClose={() =>
            setOpenRemoveConfimation({flag: false, bodyTxt: ''})
          }
          handleConfirmation={openRemoveConfimation?.callbackFunc}
        />
      </Box>
      <CCLoader
        loading={
          loading ||
          isLoading ||
          (!!selectedChapter && isChapterMovesLoading)
        }
      />
    </Box>
  );
}

export default Study;
